import { useEffect, useState } from "react";

import { styled } from '@mui/material/styles';

import { Auth, I18n } from 'aws-amplify';
import { Authenticator, useAuthenticator, View, translations, SelectField } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { lngs } from "../../../i18n";

import { useNavigate, useLocation } from 'react-router-dom';
import { Grid, Button } from '@mui/material';
import backgroundImage from '../../../assets/images/background.png';
import logoWit from '../../../assets/images/logo_wit_1280x500.png';
import PrivacyPolicy from "../../../components/privacypolicy/PrivacyPolicyModal";

const RootGrid = styled(Grid)(({ theme }) => ({
    height: '100%',
    position: 'absolute'
}));

const LeftImageGrid = styled(Grid)(({ theme }) => ({
    backgroundColor: theme.palette.neutral,
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
}));

const ContentGrid = styled(Grid)(({ theme }) => ({
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
}));

const ContentBody = styled('div')(({ theme }) => ({
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xl')]: {
        justifyContent: 'center'
    }
}));

const Footer = styled('div')(({ theme }) => ({
    padding: "5px 10px",
    position: "fixed",
    bottom: 0,
    right: 0
}));

I18n.putVocabularies(translations);
I18n.setLanguage('en');

I18n.putVocabulariesForLanguage('en', {
    'No profile?': 'No profile?',
    'Already registered?': 'Already registered?',
    'Back to Sign in': 'Back to Sign in'
});

const formFields = {
    signIn: {
        username: {
            isRequired: true,
            labelHidden: true
        },
        password: {
            isRequired: true,
            labelHidden: true
        },
    },
    signUp: {
        name: {
            order: 1,
            isRequired: true,
            labelHidden: true
        },
        family_name: {
            order: 2,
            isRequired: true,
            labelHidden: true
        },
        phone_number: {
            order: 3,
            isRequired: true,
            dialCode: '+27',
            labelHidden: true
        },
        email: {
            order: 4,
            isRequired: true,
            labelHidden: true
        },
        username: {
            order: 5,
            isRequired: true,
            labelHidden: true
        },
        password: {
            order: 6,
            isRequired: true,
            labelHidden: true
        },
        confirm_password: {
            order: 7,
            isRequired: true,
            labelHidden: true
        }
    },
    confirmSignUp: {
        confirmation_code: {
            isRequired: true,
            labelHidden: true
        }
    },
    confirmSignIn: {
        confirmation_code: {
            isRequired: true,
            labelHidden: true
        }
    },
    confirmVerifyUser: {
        confirmation_code: {
            isRequired: true,
            labelHidden: true
        }
    },
    resetPassword: {
        username: {
            isRequired: true,
            labelHidden: true
        }
    },
    confirmResetPassword: {
        confirmation_code: {
            isRequired: true,
            labelHidden: true
        },
        password: {
            isRequired: true,
            labelHidden: true
        },
        confirm_password: {
            isRequired: true,
            labelHidden: true
        }
    },
    forceNewPassword: {
        password: {
            isRequired: true,
            labelHidden: true
        },
        confirm_password: {
            isRequired: true,
            labelHidden: true
        }
    },
};
const signUpAttributes = ['name', 'family_name', 'phone_number', 'email', 'username', 'password', 'confirm_password'];

const components = {
    SignIn: {
        Header() {
            return (
                <h1>{I18n.get('Sign In')}</h1>
            );
        },
        Footer() {
            const { toResetPassword, toSignUp } = useAuthenticator();
            return (
                <Grid item xs={12}>
                    <div className="registreerBlok">
                        <p>{I18n.get('No profile?')}</p>
                        <Button onClick={toSignUp}>
                            {I18n.get('Create Account')}
                        </Button>
                    </div>
                    <div className="secondaryActionsBlock">
                        <p>{I18n.get('Forgot your password?')}</p>
                        <Button onClick={toResetPassword}>
                            {I18n.get('Reset your Password')}
                        </Button>
                    </div>
                </Grid>
            );
        },
    },
    SignUp: {
        FormFields() {
            return (
                <>
                    <Authenticator.SignUp.FormFields />
                    <SelectField
                        placeholder="Portal language"
                        name="custom:language"
                        type="text"
                        options={Object.keys(lngs).map((item, i) => lngs[item].nativeName)}
                    ></SelectField>
                </>
            );
        },
        Header() {
            return (
                <h1>{I18n.get('Create a new account')}</h1>
            );
        },
        Footer() {
            const { toSignIn } = useAuthenticator();
            return (
                <Grid item xs={12}>
                    <div className="registreerBlok">
                        <p>{I18n.get('Already registered?')}</p>
                        <Button onClick={toSignIn}>
                            {I18n.get('Sign in')}
                        </Button>
                    </div>
                </Grid>
            );
        },
    },
    ConfirmSignUp: {
        Header() {
            return (
                <h1>{I18n.get('Verify')}</h1>
            );
        },
        Footer() {
            const { toSignIn } = useAuthenticator();
            return (
                <Grid item xs={12}>
                    <div className="registreerBlok">
                        <Button onClick={toSignIn}>
                            {I18n.get('Back to Sign in')}
                        </Button>
                    </div>
                </Grid>
            );
        },
    },
    ConfirmSignIn: {
        Header() {
            return (
                <h1>{I18n.get('Confirming')}</h1>
            );
        },
        Footer() {
            const { toSignIn } = useAuthenticator();
            return (
                <Grid item xs={12}>
                    <div className="registreerBlok">
                        <Button onClick={toSignIn}>
                            {I18n.get('Back to Sign in')}
                        </Button>
                    </div>
                </Grid>
            );
        },
    },
    ResetPassword: {
        Header() {
            return (
                <h1>{I18n.get('Reset your Password')}</h1>
            );
        },
        FormFields() {
            <Authenticator.ResetPassword.FormFields />
        },
    },
    ConfirmResetPassword: {
        Header() {
            return (
                <h1>{I18n.get('Reset your Password')}</h1>
            );
        },
    },
};

const services = {
    async handleSignUp(formData) {
        let { username, password, attributes } = formData;
        let languages = Object.keys(lngs).map((item, i) => {
            return { key: i, value: item, text: lngs[item].nativeName }
        });
        let index = languages.map(item => item.text).indexOf(attributes["custom:language"]);
        attributes["custom:language"] = index !== -1 ? languages[index].value : null;
        return Auth.signUp({
            username,
            password,
            attributes,
            autoSignIn: {
                enabled: true,
            },
        });
    },
};

function Login(props) {

    const { route } = useAuthenticator((context) => [context.route]);
    const location = useLocation();
    const navigate = useNavigate();
    let from = location.state?.from?.pathname || '/';
    useEffect(() => {
        if (route === 'authenticated') {
            navigate(from, { replace: true });
        }
    }, [route, navigate, from]);

    return (
        <RootGrid container >
            <LeftImageGrid item sm={5} xs={12}>
                <img src={logoWit} style={{ width: '80%' }} alt="root"></img>
            </LeftImageGrid>
            <ContentGrid item sm={7} xs={12} >
                <ContentBody>
                    <View className="auth-wrapper" style={{ margin: "0 auto" }}>
                        <Authenticator
                            services={services}
                            formFields={formFields}
                            signUpAttributes={signUpAttributes}
                            components={components}
                        >
                        </Authenticator>
                    </View>
                </ContentBody>
                <Footer>
                    <PrivacyPolicy />
                </Footer>
            </ContentGrid>
        </RootGrid>
    );
}

export default Login;